export const API_ADMIN_MEDICATIONS = 'oneplatform/admin-panel/medications';
export const API_ADMIN_PAP_FORMS = 'oneplatform/admin-panel/pap-forms';
